import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ConvertToDateTimeAu } from '@shared/utils/datetime.helper';

@Pipe({
  standalone: true,
  name: 'dateFormat'
})

export class DateFormatPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(value: Date | string | undefined | null, formatType: DateFormatType = DateFormatType.Short, auTime = false): string {
    if (value === undefined || value === null) return '-';

     let date: Date;

    if(typeof value === 'string'){
      const parsed = Date.parse(value);
      if (isNaN(parsed)) return '-';
      date = new Date(parsed);
    } else {
      date = value;
    }

    if(auTime){
      date = ConvertToDateTimeAu(date);
    }

    let format: string;
    switch (formatType) {
      case DateFormatType.Middle:
        format = 'dd MMM yyyy'; // Example: 31 Dec 2024
        break;
      case DateFormatType.Long:
        format = 'dd MMMM yyyy'; // Example: 31 December 2024
        break;
      default:
        format = 'dd/MM/yyyy'; // Example: 31/12/2024
        break;
    }

    const formattedDate = this.datePipe.transform(date, format);

  
    return formattedDate ?? '-';
  }
}

export enum DateFormatType {
  Short = 'short',
  Middle = 'middle',
  Long = 'long'
}
